export default {
    active_requirement_orders: "Активдүү тапшырма-буйрутмалар",
    add_laboratory_service: "Лабораториялык кызматты кошуу",
    after_finished_fixed: "аяктагандан кийин",
    can_have_dental_work: "Стоматологиялык иштерди камтышы мүмкүн",
    cannot_change_services_that_already_have_laboratory_services_attached: "Алар менен байланышкан лабораториялык иштери бар кызматтарды жумуш буйругунан өчүрө албайсыз.",
    carcass: "Frame",
    deleted_from_treatment: "Дарылоодон чыгарылды",
    delivery_date: "Тапшыруу датасы",
    dental_work: "Тиштехникалык иштер",
    do_you_confirm_cancel_laboratory_order: "Жумуш заказын чын эле жокко чыгаргыңыз келеби?",
    do_you_confirm_laboratory_order_finish: "Жумуш бейтапка тапшырылганын ырастайсызбы? Ырасталгандан кийин дарыгердин эмгек акысы эсептелет, ал эми бул тапшырма-буйрутма боюнча өзгөртүү мүмкүн болбой калат.",
    do_you_confirm_laboratory_order_finish2: "Иш бейтапка тапшырылганын ырастайсызбы? Толтурулган жумуш буйругуна өзгөртүүлөрдү киргизүү мүмкүн эмес. Түзөтүү үчүн документти жарыялоону жокко чыгарышыңыз керек.",
    executor: "Аткаруучу",
    faintly: "Алсыз",
    field_is_required: "Талаа талап кылынат",
    fitting_date: "Ченеп көрүү датасы",
    full: "Толук",
    immediately: "Дароо",
    in_clinic: "Клиникада",
    in_lab: "Лабораторияда",
    initiated: "Демилгеленген",
    intermediate_part_design: "Орто дизайн",
    laboratories: "Лабораториялар",
    laboratory: "Лаборатория",
    laboratory_service: "Лабораториялык кызмат",
    LaboratoryOrder: "Жумуш тартиби",
    logics_on_laboratory_services_deduction: "Иш тартиби боюнча лабораториялык иштерди кемитүү логикасы",
    moderately: "Орточо",
    must_have_dental_work: "Милдеттүү түрдө стоматологиялык иштерди камтыйт",
    no_dental_work_needed_for_selected_services: "Тандалган кызматтар үчүн стоматологиялык жумуш талап кылынбайт",
    no_services: "Кызматтар жок",
    order_number: "Буйрутманын номери",
    paint_restorations: "Реставрацияларды боёп коюңуз",
    panorama: "Панорама",
    pay_all: "Баарын төлө",
    requirement_order: "Тапшырма - буйрутма",
    select_from_price: "Прайстан тандоо",
    send_to_laboratory_via_messenger: "Мессенджер аркылуу лабораторияларга жөнөтүңүз",
    shoulder: "Ийин",
    simplified: "Жөнөкөйлөштүрүлгөн",
    total_orders_for_the_amount: "Жалпы буйрутмалардын суммасы",
    when_changeing_laboratory_all_selected_services_will_be_removed_continue: "Лабораторияны алмаштырганда, бардык тандалган кызматтар тизмеден чыгарылат. Улантуу керекпи?",
    without_attachment_to_tooth: "Тишке байланышы жок"
}
